import { uniq } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import type { PracticeTest } from './PracticeTest'

export class PracticeTestColl {
  private practiceMap: ExtendedMap<PracticeTest['id'], PracticeTest>

  constructor(data: PracticeTest[]) {
    this.practiceMap = ExtendedMap.fromArr(data, 'id')
    makeAutoObservable(this)
  }

  get size() {
    return this.practiceMap.size
  }
  get toArr() {
    return [...this.practiceMap.values()]
  }

  get checkedIds() {
    return uniq(
      this.practiceMap.toArr.map(({ checkedProblemIdList }) => checkedProblemIdList).flat(),
    )
  }

  get allIds() {
    return this.practiceMap.toArr.map(({ allIds }) => allIds).flat()
  }

  get allChecked() {
    return this.practiceMap.toArr.map(({ allChecked }) => allChecked).every((checked) => checked)
  }

  allCheck = () => {
    this.practiceMap.forEach(({ allCheck }) => allCheck())
  }

  clearAllCheck = () => {
    this.practiceMap.forEach(({ clearAllCheck }) => clearAllCheck())
  }

  toggleAllCheck = (checked = false) => {
    this.practiceMap.toArr.forEach(({ allCheck, clearAllCheck }) => {
      checked ? allCheck() : clearAllCheck()
    })
  }

  adds = (coll: PracticeTestColl) => {
    const keys = [...coll.practiceMap.keys()]
    keys.forEach((key) => {
      const hasMap = this.practiceMap.has(key)
      if (!hasMap) {
        const target = coll.practiceMap.get(key)
        if (target) {
          this.practiceMap.set(key, target)
        }
      }
    })
  }

  delete = (id) => {
    this.practiceMap.delete(id)
  }
  deletes = (ids) => {
    this.practiceMap.deletes(ids)
  }
  get = (id: PracticeTest['id']) => {
    return this.practiceMap.get(id)
  }
}
